import React, { useEffect, useRef, useState } from "react";
// MUI
import { Grid2 } from "@mui/material";
//styling
import styles from "./Blueprints.module.scss";
// Icons
import { ReactComponent as BlueprintSite } from "../../../../../GlobalAssets/svg/clonesite12.svg";
import { ReactComponent as UploadIcon } from "../../../../../GlobalAssets/svg/UploadIcon.svg";
// Local import
import CustomButton from "../../../../../GlobalComponents/CustomButton/CustomButton";
import BlueprintCard from "../Components/BlueprintCard/BlueprintCard";
import CreateBlueprint from "../Components/CreateBlueprint/CreateBlueprint";
import { Actions } from "../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../Utils/storeUtils";
import FormPopup from "../../../../../GlobalComponents/FormPopup/FormPopup";
import { useSelector } from "react-redux";
import axios from "axios";
import { getAuthorizationHeader } from "../../../../../Utils/utils";
import EmptyState from "../../../../../GlobalComponents/EmptyState/EmptyState";
import PageLoading from "../../../../../GlobalComponents/PageLoading/PageLoading";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import NewPopup from "../../../../../GlobalComponents/Popup/NewPopup";
import {
  EmptyStateForBlueprints,
  NewEmptyStateForBlueprints,
} from "../../../../../Utils/roconConstants";
import NewEmptyState from "../../../../../GlobalComponents/EmptyState/NewEmptyState";
import NoData from "../../../../../GlobalComponents/NoData/NoData";
import PlanExpiredCard from "../../../../../GlobalComponents/PlanExpiredCard/PlanExpiredCard";
import { reachedMaximum } from "../../CreateSite/Components/ConstantData/CreateSiteConstantData";

export default function Blueprint({ searchValue }) {
  // Hooks and Props
  const [createBluePrint, setCreateBluePrint] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [nameLoading, setNameLoading] = useState(false);
  const [nameValid, setNameValid] = useState(null);
  const [editingBlueprintId, setEditingBlueprintId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadFile, setUploadFile] = useState();
  const [image, setImage] = useState();
  const [loadingDel, setLoadingDel] = useState(false);
  const [isUpload, setIsUpload] = useState(true);
  const [filteredBlueprints, setFilteredBlueprints] = useState([]);
  const fileInputRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [values, setValues] = useState({
    image: "",
  });
  const params = useParams();
  let orgId = parseInt(params.orgId);
  // useSelector
  const blueprintInfo = useSelector((state) => state.bluePrintInfo);
  const sitesInfo = useSelector((state) => state.sitesInfo);
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg,
  );
  const specificPlan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans,
  );

  const basePlan = specificPlan?.find((item) => item.basePlan === true) || {};
  const bundleId = basePlan?.featureDetails?.find(
    (feature) => feature.type === "LIGHTSAIL_BUNDLE_ID",
  );

  const numSitesFeature = basePlan?.featureDetails?.find(
    (feature) => feature.type === "NUM_SITES",
  );

  const cancel = basePlan?.cancel;
  const daysAfterExpiry = basePlan?.daysAfterExpiry;

  const [createBluePrintForm, setCreateBlueprintForm] = useState({
    name: "",
    siteName: "",
    siteId: "",
    siteInstallType: "",
    newName: null,
    newNameErrorMessage: null,
    file: null,
  });

  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });

  const dispatchGetAllBlueprint = () => {
    getStore().dispatch({
      type: Actions.API_GET_ALL_BLUEPRINT,
      data: { orgId: orgId },
      meta: {
        onSuccess: () => {},
        onError: () => {},
      },
    });
  };

  const ActivatePopup = (type, blueprintId) => {
    if (type === "warning") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Delete Blueprint?",
        popupSubtitle:
          "Are you sure you want to delete this blueprint? This action cannot be undone.",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          deleteBlueprint(blueprintId);
        },
      });
    } else if (type === "loading") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Deleting Blueprint...",
        popupSubtitle: "Please wait while we remove the blueprint.",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "create_error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Blueprint could not be created",
        popupSubtitle:
          typeof blueprintId === "string" && blueprintId.trim()
            ? blueprintId
            : "An error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Oops! something went wrong",
        popupSubtitle: "An error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Blueprint Deleted",
        popupSubtitle: "The selected blueprint has been successfully removed.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "created_blueprint") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Blueprint creation has started",
        popupSubtitle:
          "Your blueprint is being created and will appear in the list shortly. We'll notify you once it's ready to use.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          dispatchGetAllBlueprint();
          setPopup({ popupState: false });
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  useEffect(() => {
    dispatchGetAllBlueprint();
  }, [orgId]);

  // If page loaded with createBlueprintSiteId in URL, auto-open Create Blueprint popup and preselect site
  useEffect(() => {
    const search = window?.location?.search;
    if (!search) return;

    const searchParams = new URLSearchParams(search);
    const createSiteId = searchParams.get("createBlueprintSiteId");
    if (!createSiteId) return;

    const cloneSites = sitesInfo?.sitesList?.data;
    if (!Array.isArray(cloneSites) || cloneSites.length === 0) return;

    const site = cloneSites.find(
      (s) => String(s.siteId) === String(createSiteId),
    );
    if (!site) return;

    // open create blueprint popup and prefill site info
    setCreateBluePrint(true);
    setCreateBlueprintForm((prev) => ({
      ...prev,
      siteName: site.siteName,
      siteId: site.siteName, // CreateBlueprint expects siteId/siteName as siteName value
      orgId: orgId,
    }));

    // remove query param so it doesn't re-trigger
    const url = new URL(window.location.href);
    url.searchParams.delete("createBlueprintSiteId");
    const newUrl = url.pathname + url.search + url.hash;
    window.history.replaceState({}, document.title, newUrl);
  }, [sitesInfo?.sitesList?.data]);

  useEffect(() => {
    getStore().dispatch({ type: Actions.API_ORG_DASHBOARD });
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
    });
    getStore().dispatch({
      type: Actions.API_ALL_SITES,
      data: { orgId: orgId },
    });
    getStore().dispatch({
      type: Actions.API_SITES_LIST,
      data: { orgId: orgId },
    });
  }, [orgId]);

  useEffect(() => {
    if (uploadFile) {
      let imageUrl = URL.createObjectURL(uploadFile);
      setImage(imageUrl);
    }
  }, [uploadFile]);

  const blueprintDetails = () => {
    const getBlueprintDetail = (blueArray) => {
      return blueArray?.map((blue) => ({
        blueprintName: blue.blueprintName,
        creatorName: blue.creatorName,
        blueprintId: blue.blueprintId,
        orgId: blue.orgId,
        imagePath: blue?.imagePath,
        usedCounter: blue?.usedBlueprintCount,
        creationInProgress: blue?.creationInProgress,
      }));
    };
    const blueprintDetail = blueprintInfo?.userOrgBluePrints?.data;

    return blueprintDetail?.length > 0
      ? getBlueprintDetail(blueprintDetail)
      : [];
  };

  const blueprintData = blueprintDetails();

  const hasBlueprintInProgress = blueprintData?.some(
    (blueprint) => blueprint.creationInProgress,
  );

  // The API stores the blueprint (creationInProgress) before the backup finishes,
  // so keep refreshing until it is done building.
  useEffect(() => {
    if (!hasBlueprintInProgress) return;

    const pollBlueprints = setInterval(() => {
      dispatchGetAllBlueprint();
    }, 5000);

    return () => clearInterval(pollBlueprints);
  }, [hasBlueprintInProgress, orgId]);

  const setBlueprintsSearch = (searchValue) => {
    if (!searchValue.trim()) {
      return blueprintData;
    }
    return blueprintData.filter((site) =>
      site.blueprintName.toLowerCase().includes(searchValue.toLowerCase()),
    );
  };

  useEffect(() => {
    const filtered = setBlueprintsSearch(searchValue);
    if (JSON.stringify(filtered) !== JSON.stringify(filteredBlueprints)) {
      setFilteredBlueprints(filtered);
    }
  }, [searchValue, blueprintData, setBlueprintsSearch]);

  const deleteBlueprint = (blueprintId) => {
    ActivatePopup("loading");
    getStore().dispatch({
      type: Actions.API_DELETE_BLUEPRINT,
      data: { blueprintId: blueprintId },
      meta: {
        onSuccess: () => {
          dispatchGetAllBlueprint();
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          ActivatePopup("success");
        },
        onError: () => {
          dispatchGetAllBlueprint();
          ActivatePopup("error");
        },
      },
    });
  };

  const apiDeleteImage = (blueprintId) => {
    setLoadingDel(true);
    getStore().dispatch({
      type: Actions.API_REMOVE_BLUEPRINT_IMAGE,
      data: { blueprintId: blueprintId },
      meta: {
        onSuccess: () => {
          setLoadingDel(false);
          dispatchGetAllBlueprint();
          resetImageState();
        },
        onError: () => {
          dispatchGetAllBlueprint();
        },
      },
    });
  };

  const apiImageReUpload = (blueprintId, orgId) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("blueprintId", blueprintId);
    formData.append("orgId", orgId ? orgId : -1);

    getStore().dispatch({
      type: Actions.API_IMAGE_UPLOAD_BLUEPRINT,
      data: formData,
      meta: {
        onSuccess: () => {
          setLoading(false);
          dispatchGetAllBlueprint();
          setIsPopupOpen(false);
          resetImageState();
        },
        onError: () => {
          dispatchGetAllBlueprint();
          setIsPopupOpen(false);
        },
      },
    });
  };

  const flushStateVariables = () => {
    setCreateBluePrint(false);
    setImage(null);
    setErrorMessage("");
    setCreateBlueprintForm({
      name: "",
      siteName: "",
      orgId: "",
      role: "",
      siteId: "",
      file: null,
      image: null,
    });
  };

  const getApiErrorMessage = (error) => {
    const data = error?.response?.data;
    if (typeof data === "string" && data.trim()) {
      return data;
    }
    return data?.message || "";
  };

  const creationStarted = () => {
    flushStateVariables();
    setLoading(false);
    ActivatePopup("created_blueprint");
    dispatchGetAllBlueprint();
    getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
  };

  const createBlueprint = () => {
    try {
      setLoading(true);

      const imageBlob = new FormData();
      imageBlob.append("file", createBluePrintForm.file);
      imageBlob.append("blueprintName", createBluePrintForm.name);
      imageBlob.append("orgId", orgId);
      imageBlob.append("siteName", createBluePrintForm.siteName);
      imageBlob.append("bundleId", bundleId?.limitOrAvailablity);

      axios
        .post(
          `${process.env.REACT_APP_BACK_END_API_BASE_URL}/AWS/createBlueprint`,
          imageBlob,
          getAuthorizationHeader(),
        )
        .then(() => {
          creationStarted();
        })
        .catch((error) => {
          const statusCode =
            error?.response?.status || error?.status || error?.code;

          const isTimeout =
            statusCode === 504 ||
            error?.code === "ECONNABORTED" ||
            error?.code === "ERR_NETWORK" ||
            error?.message?.includes("timeout") ||
            error?.message?.includes("Network Error");

          if (isTimeout) {
            creationStarted();
            return;
          }

          console.error("Error creating blueprint:", error);
          setLoading(false);
          ActivatePopup("create_error", getApiErrorMessage(error));
        });
    } catch (e) {
      console.error("Error in createBlueprint:", e);
      flushStateVariables();
      ActivatePopup("error");
      setLoading(false);
    }
  };

  useEffect(() => {
    const myTimeout = setTimeout(() => {
      if (createBluePrintForm.name) {
        setNameLoading(true);
        getStore().dispatch({
          type: Actions.API_IS_VALID_BLUEPRINT_NAME,
          data: {
            blueprintName: createBluePrintForm.name,
            orgId: createBluePrintForm.orgId ? createBluePrintForm.orgId : -1,
          },
          meta: {
            onSuccess: (data) => {
              setNameLoading(false);
              if (data) {
                setNameValid(true); // Set name as valid
                setCreateBlueprintForm((prev) => ({
                  ...prev,
                  newName: false,
                  newNameErrorMessage: null,
                }));
              } else {
                setNameValid(false); // Set name as invalid
                setCreateBlueprintForm((prev) => ({
                  ...prev,
                  newName: true,
                  newNameErrorMessage: "The name already exists!",
                }));
              }
            },
            onError: () => {
              setNameLoading(false);
              setNameValid(false); // Set name as invalid on error
              setCreateBlueprintForm((prev) => ({
                ...prev,
                newName: true,
                newNameErrorMessage: "An error occurred during validation.",
              }));
            },
          },
        });
      } else {
        setNameLoading(false);
        setNameValid(null); // Reset name validity
        setCreateBlueprintForm((prev) => ({
          ...prev,
          newName: null,
          newNameErrorMessage: null,
        }));
      }
    }, 500);

    return () => {
      clearTimeout(myTimeout);
    };
  }, [createBluePrintForm.name, createBluePrintForm.orgId]);

  const handleEditClick = (blueprintId) => {
    setEditingBlueprintId(
      blueprintId === editingBlueprintId ? null : blueprintId,
    );
  };

  const resetImageState = () => {
    setValues({ ...values, image: "" });
    setImage(null);
  };

  const isCreateButtonDisabled =
    !createBluePrintForm?.siteId ||
    !createBluePrintForm?.name ||
    createBluePrintForm?.name.length < 4 ||
    createBluePrintForm?.name.length > 24 ||
    !!createBluePrintForm?.newNameErrorMessage ||
    !nameValid ||
    !!errorMessage;
  return (
    <>
      {blueprintInfo?.userOrgBluePrints ? (
        <>
          {specificPlan?.length > 0 ? (
            <Grid2 className={styles.Container}>
              {blueprintData?.length > 0 ? (
                <>
                  <Grid2 className={styles.headerFlexBox}>
                    <Grid2 className={styles.header}>Blueprints</Grid2>
                    <Grid2 className={styles.button}>
                      <CustomButton
                        onClick={() => {
                          setCreateBluePrint(true);
                        }}
                      >
                        Create Blueprint
                      </CustomButton>
                    </Grid2>
                  </Grid2>
                  {filteredBlueprints?.length > 0 ? (
                    <Grid2 className={styles.BlueprintMainContainer}>
                      {filteredBlueprints?.map((blueprint, index) => {
                        return (
                          <BlueprintCard
                            key={blueprint.blueprintId}
                            imagePath={blueprint.imagePath}
                            blueprintName={blueprint.blueprintName}
                            name={blueprint.creatorName}
                            orgId={orgId}
                            blueprintId={blueprint.blueprintId}
                            usedCounter={blueprint.usedCounter}
                            creationInProgress={blueprint.creationInProgress}
                            loading={loading}
                            setLoading={setLoading}
                            isEditing={
                              editingBlueprintId === blueprint.blueprintId
                            }
                            onEditClick={() =>
                              handleEditClick(
                                blueprint.blueprintId,
                                blueprint.blueprintName,
                              )
                            }
                            // API's
                            deleteBlueprint={() =>
                              ActivatePopup("warning", blueprint.blueprintId)
                            }
                            dispatchGetAllBlueprint={() =>
                              dispatchGetAllBlueprint()
                            }
                            apiDeleteImage={() =>
                              apiDeleteImage(blueprint.blueprintId)
                            }
                            apiImageReUpload={() =>
                              apiImageReUpload(
                                blueprint.blueprintId,
                                blueprint.orgId,
                              )
                            }
                            image={image}
                            setImage={setImage}
                            values={values}
                            setValues={setValues}
                            setUploadFile={setUploadFile}
                            isUpload={isUpload}
                            setIsUpload={setIsUpload}
                            fileInputRef={fileInputRef}
                            loadingDel={loadingDel}
                            UploadIcon={UploadIcon}
                            isPopupOpen={isPopupOpen}
                            setIsPopupOpen={setIsPopupOpen}
                            selectedOrg={selectedOrg}
                            numSitesFeature={numSitesFeature}
                            reachedMaximum={reachedMaximum}
                          />
                        );
                      })}
                    </Grid2>
                  ) : (
                    <Grid2 className={styles.noData}>
                      <NoData message={"No filtered Blueprints"} />
                    </Grid2>
                  )}
                </>
              ) : (
                <EmptyState
                  header={EmptyStateForBlueprints.header}
                  subHeader={EmptyStateForBlueprints.subHeader}
                  // icon={BlueprintSite}
                  title={EmptyStateForBlueprints.title}
                  subTitle={EmptyStateForBlueprints.subTitle}
                  title1={EmptyStateForBlueprints.title1}
                  subTitle1={EmptyStateForBlueprints.subTitle1}
                  subTitle2={EmptyStateForBlueprints.subTitle2}
                  subTitle3={EmptyStateForBlueprints.subTitle3}
                  create={EmptyStateForBlueprints.create}
                  onClick={() => {
                    setCreateBluePrint(true);
                  }}
                  docsheader={EmptyStateForBlueprints.docsheader}
                  docsSubheader={EmptyStateForBlueprints.docsSubheader}
                  docsbutton={EmptyStateForBlueprints.docsbutton}
                  docsbuttonOnclick={() => {
                    window.open(
                      "https://docs.roconpaas.io/home/getting-started-4/",
                      "_blank",
                    );
                  }}
                  liveHeader={EmptyStateForBlueprints.liveHeader}
                  liveSubheader={EmptyStateForBlueprints.liveSubheader}
                  liveButton={EmptyStateForBlueprints.liveButton}
                  livebuttonOnclick={() => {
                    window.open(
                      "https://docs.roconpaas.io/home/getting-started-4/",
                      "_blank",
                    );
                  }}
                />
              )}

              {((cancel === true && daysAfterExpiry >= 2) ||
                daysAfterExpiry >= 2) && (
                <PlanExpiredCard org={selectedOrg} plan={basePlan} />
              )}
            </Grid2>
          ) : (
            <NewEmptyState
              header={NewEmptyStateForBlueprints.header}
              subHeader={NewEmptyStateForBlueprints.subHeader}
              icon={BlueprintSite}
              title={
                <span>
                  Build Smarter with
                  <span style={{ color: "#135FC2" }}> Blueprints </span>
                </span>
              }
              subTitle={NewEmptyStateForBlueprints.subTitle}
            />
          )}
        </>
      ) : (
        <PageLoading />
      )}

      <section>
        <FormPopup
          trigger={popup.popupState}
          setTrigger={setPopup}
          type={popup.popupType}
          title={popup.popupTitle}
          subtitle={popup.popupSubtitle}
          button={popup.popupButton}
          cancel={popup.popupCancel}
          buttonTitle={popup.popupButtonTitle}
          buttonFunction={popup.popupButtonFunction}
          cancelTitle={popup.popupCancelTitle}
          cancelFunction={popup.popupCancelFunction}
        />
      </section>
      <NewPopup
        trigger={createBluePrint}
        header={"Create Blueprint"}
        closePopup={() => {
          flushStateVariables();
        }}
        backPopup="Cancel"
        backOnClick={() => {
          flushStateVariables();
        }}
        nextpopup={"Create"}
        nextOnClick={() => {
          createBlueprint();
        }}
        loading={loading}
        disabled={isCreateButtonDisabled}
      >
        <CreateBlueprint
          createBluePrintForm={createBluePrintForm}
          setCreateBlueprintForm={setCreateBlueprintForm}
          nameLoading={nameLoading}
          nameValid={nameValid}
          loading={loading}
          values={values}
          setValues={setValues}
          image={image}
          setImage={setImage}
          fileInputRef={fileInputRef}
          resetImageState={resetImageState}
          UploadIcon={UploadIcon}
          sitesInfo={sitesInfo}
          createBlueprint={createBlueprint}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
        />
      </NewPopup>
    </>
  );
}
